<div (mouseleave)="dismissPopover()" class="py-2">
  <ion-list>
    <ion-item
      class="cursor-pointer"
      (click)="dismissPopover('download')"
      *ngIf="paid"
    >
      <ion-icon name="download-outline" class="mr-2"></ion-icon>
      Download
    </ion-item>
    <ion-item
      class="cursor-pointer text-red-400"
      (click)="dismissPopover()"
      *ngIf="!paid"
    >
      <ion-icon name="information-circle-outline" class="mr-2"></ion-icon>
      Please complete payment to unlock download
    </ion-item>
    <ion-item
      class="cursor-pointer"
      (click)="dismissPopover('print')"
      *ngIf="paid"
    >
      <ion-icon name="print-outline" class="mr-2"></ion-icon>
      Print
    </ion-item>
  </ion-list>
</div>
